import mixins from "../mixin";

export default {
    name: "home",
    mixins: [mixins]
};